export interface ApiOptions {
  method?: string;
  body?: unknown;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}

export async function api<T = unknown>(path: string, opts: ApiOptions = {}): Promise<T> {
  const res = await fetch(path, {
    method: opts.method,
    headers: { "Content-Type": "application/json", ...opts.headers },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    signal: opts.signal,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error || "Chyba");
  return data as T;
}

// Persist a new manual order for one task kind ('habit' | 'onetime').
export async function saveOrder(kind: string, ids: number[]): Promise<void> {
  await api("/api/tasks/reorder", { method: "POST", body: { kind, order: ids } });
}

// Navigate to a user's public profile (works logged-out; supports deep links).
export const openProfile = (uid: number): void => { window.location.href = "/u/" + uid; };
